module.exports = __webpack_public_path__ + "static/media/IMG_1703.56e27dd8.JPG";